import type { LiveAiChatMessage } from './ai-chat-live-content'
import type { AiChatMessagesQuery } from '@/graphql/queries/aiChatMessagesQuery.gql.generated'

export function normalizeAiChatMessage(
  message: AiChatMessagesQuery['aiChatMessages'][number],
): LiveAiChatMessage {
  const request = message.inputRequest

  return {
    ...message,
    inputRequest: request
      ? {
          ...request,
          questions: request.questions.map((question) => ({
            ...question,
            recommendedOptionId: question.recommendedOptionId ?? null,
            options: question.options.map((option) => ({
              ...option,
              description: option.description ?? null,
            })),
          })),
          answers: request.answers.map((answer) => ({
            ...answer,
            customText: answer.customText ?? null,
          })),
        }
      : null,
  }
}
